import { isArray } from "lodash"

export const transportMapped = (arr) => {
    if (isArray(arr))
        return arr.map((item) => {
            return { title: item.title, value: item.name }
        })

    return [];
}